<template>
  <div>
    <v-container fluid style="padding: 0 25px;">
      <v-card class="card2" style="margin-top: 10px">
        <v-card-text style="margin-top: -15px;">
          <div style="display: flex;justify-content: space-between;">
            <span style="font-weight: 500;font-size: 28px;"> Model List</span>
            <div style="display: flex;">
              <div class="pa-2 search-panel">
                <div class="custom-search-input-wrapper">
                  <div class="custom-search-input-container">
                    <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                    <input
                      id="search-modelid-gptmodelmanagement"
                      type="text"
                      placeholder="Model ID"
                      class="custom-search-input"
                      v-model="searchModelId"
                      @keypress="isNumberpositive($event)"
                      @keydown.enter="Search"
                    />
                    <v-icon 
                      class="clear-icon" 
                      :style="searchModelId ? '' : 'color: transparent !important;'"
                      @click="searchModelId = ''"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </div>

                <div class="custom-search-input-wrapper">
                  <div class="custom-search-input-container">
                    <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                    <input
                      id="search-modelname-gptmodelmanagement"
                      type="text"
                      placeholder="Model Name"
                      class="custom-search-input"
                      v-model="searchModelName"
                      @keydown.enter="Search"
                    />
                    <v-icon 
                      :style="searchModelName ? '' : 'color: transparent !important;'"
                      class="clear-icon" 
                      @click="searchModelName = ''"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </div>

                <v-btn
                  id="button-search-gptmodelmanagement"
                  color="primary"
                  class="ml-2"
                  variant="elevated"
                  @click="Search"
                  style="display: none;"
                >
                  <v-icon start>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </div>

              <div class="custom-vertical-divider"></div>

              <!-- ส่วนปุ่มการทำงาน -->
              <div style="display: flex;">
                <div class="action-controls">
                  <!-- Import Button -->
                  <v-btn
                    id="button-import-gptmodelmanagement"
                    color="info"
                    class="control-btn import-btn"
                    variant="flat"
                    size="large"
                    prepend-icon="mdi-file-import"
                    @click="triggerFileUpload"
                    rounded="lg"
                  >
                    IMPORT
                    <v-tooltip activator="parent" location="top">
                      Import file configuration
                    </v-tooltip>
                  </v-btn>
                  
                  <!-- Create Button -->
                  <v-btn
                    id="button-create-gptmodelmanagement"
                    color="primary"
                    class="control-btn create-btn"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-plus"
                    @click="Add()"
                    rounded="lg"
                  >
                    CREATE
                    <v-tooltip activator="parent" location="top">
                      Create new GPT model
                    </v-tooltip>
                  </v-btn>
                </div>
                
                <!-- Hidden File Uploader -->
                <DragDropFile
                  ref="fileUploader"
                  :dialog="true"
                  :DragDrop="false"
                  :ShowListFile="false"
                  :NameButton="nameButton"
                  accept=".json"
                  @filesUploaded="processUpload($event)"
                  :allowType="['application/json']"
                  class="d-none"
                />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          style="padding: 0px 25px 0 25px;"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: start;"><span>{{ item.modelDisplay }}</span></td>
              <td><span>{{ item.modelName }}</span></td>
              <td>
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      icon
                      v-bind="props"
                      variant="text"
                      density="comfortable"
                    >
                      <v-icon id="icon-iconmenu-gptmodelmanagement" size="22"
                        >mdi-dots-horizontal</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list style="border-radius: 15px;">
                    <v-list-item @click="changePublishNow(item, true)">
                      <v-list-item-title id="list-publish-gptmodelmanagement"
                        >Publish</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item @click="Replace(item.modelId, item.modelName)">
                      <v-list-item-title id="list-replace-gptmodelmanagement">{{
                        $t("gpt_model_management_replace")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="Version(item.modelId, item.modelIDGroup)"
                    >
                      <v-list-item-title id="list-version-gptmodelmanagement">{{
                        $t("gpt_model_management_version_history")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Exportfileconfig(item.modelId)">
                      <v-list-item-title
                        id="list-exportfileconfig-gptmodelmanagement"
                        >{{
                          $t("gpt_model_management_export_file_config")
                        }}</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td style="text-align: start">{{ item.provider }}</td>
              <td style="text-align: center"><span style="margin-left: -22px;">{{ item.modelNameDisplay }}</span></td>
              <td style="text-align: center"><span style="margin-left: -22px;">{{ item.createBy }}</span></td>
              <td style="text-align: center">
                <span style="margin-left: -20px;display: flex; justify-content: center; align-items: center;">
                  <v-chip 
                    :color="item.isPublish == true ? 'success' : '#FFA726FD'" 
                    style="width: 90px; display: flex; justify-content: center; align-items: center;"
                    rounded="xl"
                    label
                  >
                    <span style="font-weight: 300;">{{ item.isPublish == true ? "Published" : "Draft" }}</span>
                  </v-chip>
                </span>
              </td>
              <td style="text-align: center">
                <div class="action-group" style="display: flex; justify-content: center">
                  <v-btn
                    id="button-edit-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    icon
                  >
                    <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <!-- <div class="action-divider" v-if="item.modelDisplay != 1"></div> -->
                  
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item)"
                    v-if="item.modelDisplay != 1"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <!-- Header with Title and Close Button -->
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Are you sure you want to delete model {{ deleteItem.modelDisplay }} "<strong>{{ deleteItem.modelName }}</strong>" ?
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Replace -->
    <v-dialog v-model="dialog_replace" persistent max-width="600px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_replace") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-swap-horizontal</v-icon>
                <span style="font-size: 16px;">Replace Model</span>
          </div>
            <div style="margin-bottom: 2%">
              <span style="font-weight: 600;">{{ replace_modelName }}</span>
              <v-icon size="20">mdi-chevron-double-right</v-icon>
              <span style="color: #C32E0E; font-weight: bold">
                {{replace_modelName2}}
              </span>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    id="model-autocomplete-popupreplace-gptmodelmanagement"
                    :label="'Model*'"
                    :rules="[rules.required]"
                    :items="replace_modelid_lists"
                    item-title="modelName"
                    item-value="modelIDGroup"
                    v-model="replace_modelid_list"
                    class="config-input"
                    clearable
                    outlined
                    required
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                    @update:modelValue="onModelChange"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Outlined red Close button with left icon -->
          <v-btn
            class="replace-close-btn"
            variant="outlined"
            density="comfortable"
            @click="dialog_replace = false"
            style="margin-right: 15px;"
          >
            <v-icon left size="18">mdi-close</v-icon>
            {{$t("close")}}
          </v-btn>

          <!-- Gradient orange Save button with floppy icon -->
          <v-btn
            id="button-replacesave-popupreplace-gptmodelmanagement"
            class="replace-save-btn"
            variant="elevated"
            density="comfortable"
            @click="ReplaceSave"
          >
            <v-icon left size="18">mdi-floppy</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Version -->
    <v-dialog v-model="dialog_version" max-width="800px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container style="padding: 0;">
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-clock-time-three-outline</v-icon>
              <span style="font-size: 16px;">Version History</span>
          </div>
            <v-data-table-server
              id="table-dialogversion-gptmodelmanagement"
              :items-per-page="options_version.itemsPerPage"
              :items-length="totalTable_version"
              v-model:options="options_version"
              :items="menus_version"
              :headers="headers_version_history"
              :items-per-page-options="[5, 10, 15]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: start;">
                    <div style="display: flex;align-content: center;align-items: center;justify-content: flex-start;">
                      <div>{{ item.versioning }}</div>
                      <span
                        v-if="item.isPublish === true"
                        style="z-index: 1;">
                        <v-chip class="ml-3" size="small" label style="border-radius: 10px;background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%); color: #fff; font-weight: 500;">
                          {{ $t("latest")
                        }}</v-chip>
                      </span>
                    </div>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateDate }}</span></td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn 
                        icon 
                        variant="text"
                        density="comfortable"
                        v-bind="props">
                          <v-icon
                            id="icon-iconmenu-popupversion-gptmodelmanagement"
                            size="22"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list style="border-radius: 15px;">
                        <!--Restore-->
                        <v-list-item
                          :key="item.modelId"
                          @click="changeRestoreNewVersion(item)"
                        >
                          <v-list-item-title
                            id="list-restore-popupversion-gptmodelmanagement"
                            >Restore</v-list-item-title
                          >
                        </v-list-item>
                        <!--View-->
                        <v-list-item @click="view(item)">
                          <v-list-item-title
                            id="list-view-popupversion-gptmodelmanagement"
                            >View</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateBy }}</span></td>
                </tr>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="close-btn" @click="dialog_version = false">
            {{$t("close")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog version history view-->
    <v-dialog v-model="dialog_View">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history_detail") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ModelManagement
              v-if="dialog_View"
              :LLmsModel="GPTModel"
              :editAction="null"
              :modelID="view_modelID"
              :GetDDModel="isParam"
              :page="isPage"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_View = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>


<script>
import ModelManagement from "@/components/ModelManagement.vue";
import DragDropFile from "@/components/DragDropFile.vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";

// use i18n for internationalization
export default {
  name: "GPTModelManagement",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: { ModelManagement, DragDropFile },
  
  data: () => ({
    loadingTable: false,
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    dialog_delete: false,
    deleteItem: null,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    options_version: {
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDVector: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDModel: [
      {
        provider: "Azure",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure",
        model: "gpt-4",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-postgresql",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-16k-postgresql",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-4-postgresql",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-Internet",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-16k-Internet",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-4-Internet",
        maxPrompt: 6000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure News",
        model: "gpt-4",
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    headers: [],
    headers_version_history: [],
    DDGender: [
      {
        id: "m",
        name: "Male",
      },
      {
        id: "f",
        name: "Female",
      },
    ],

    searchModelName: "",
    searchModelId: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    GPTModel: {
      typeLLM: null,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      versioning: null,
      isPublish: false,
      modelIDGroup: null,
      modelDisplay: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      typingSpeed: null,
      isBypass: null,
      isAllowImage: null,
      isFeedback: null,
      groupReplaceID: null,
      productGroupID: null,
      cosine: null,
      isLongTerm_Memory: null,
      isChainMassage: null,
      lenChainMassage: null,
      len_ShortMemory: null,
      timeSecondChainMassage: null,
      maximumChatInput: null,
      monitorLineUserId: null,
      isShowNameUserMonitor: null,
      monitorSocialId: null,
      forbiddenWord: null,
      GuardRailModelID: null,
      enableTime: null,
      timeZone: null,
      jsonRequest: null,
      isAllowLLMChange: null,
      productTopVDB: null,
      productCosine: null,
      loadingBarFlag: null,
      loadingBarTime: null,
    },
    dialog_replace: false,
    dialog_View: false,
    replace_modelid: 0,
    replace_modelName: "",
    replace_modelName2: "",
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    sortBy: [],
    sortDesc: [],

    isParam: "getModel",
    isPage: "Model Creator",
    view_modelID: null,
    view_Model: {
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: null,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      maximumChatInput: 200000,
      enableTime: null,
      timeZone: null,
    },
    uploadedFiles: [],
    nameButton: "IMPORT FILE",
    entity: null,
    jsonData: {},
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        if (this.menus_modelid_version != 0)
          this.Version(
            this.menus_modelid_version,
            this.menus_modeliddisplay_version
          );
      },
      deep: true,
    },
  },
  methods: {
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:
      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (this.$refs.fileUploader && typeof this.$refs.fileUploader.openFileDialog === 'function') {
        this.$refs.fileUploader.openFileDialog();
      } 
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput = this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchModelName,
        modelDisplayId: parseInt(self.searchModelId),
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          self.loading = false;
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      const { itemsPerPage } = self.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchModelName,
        modelDisplayId: parseInt(self.searchModelId),
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(item) {
      this.deleteItem = item;
      this.dialog_delete = true;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      
      try {
        self.dialog_delete = false;
        self.dialog = true;
        
        self.$call.DeleteGPTModel(
          self.deleteItem.modelId,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.EditdialogUser = false;
              self.Get();
            } else if (dataResponse.status == 1) {
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: true,
                confirmButtonText: this.$t("gotIt"),
                confirmButtonColor: "#d33",
              });
            }
            self.dialog = false;
            self.deleteItem = null;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            self.deleteItem = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
        self.deleteItem = null;
      }
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: item.modelId,
        },
      });
    },
    Clear() {
      let self = this;
      self.EditdialogUser = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      return (
        inputValue.length <= this.maxLengthChar ||
        "ฝรุณาฝรอฝข้อมูลตัวอัฝษรไม่เฝิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
      );
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return "required.";
      return (
        (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (
        (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeProvider(value) {
      let self = this;
      if (value == null || value == "") {
        self.DDModelShow = self.DDModel;
        return "required.";
      }
      let ddm = self.DDModel.filter((e) => e.provider == value);
      if (ddm.length != 0) {
        self.DDModelShow = self.DDModel.filter((e) => e.provider == value);
      } else {
        self.DDModelShow = self.DDModel;
      }
    },
    changeModel(value) {
      let self = this;
      if (value == null || value == "") {
        self.maxLengthChar = 0;
        return "required.";
      }
      let ddm = self.DDModel.find((e) => e.model == value);
      if (ddm) {
        self.maxLengthChar = self.DDModel.find(
          (e) => e.model == value
        ).maxPrompt;
      }
    },
    changePublishNow(item, is_publish) {
      let self = this;
      self.dialog = true;
      if (item.isPublish == true && is_publish == true) {
        self.dialog = false;
        self.$swal.fire({
          icon: "info",
          title: this.$t("alreadyPublishedModel"),
          showConfirmButton: true,
          confirmButtonText: this.$t("gotIt"),
          confirmButtonColor: "#4BB543",
        });
        return;
      }
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + 
                this.$t("publish") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 2500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.Get();
          }
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    changeRestoreNewVersion(item) {
      let self = this;
      self.dialog = true;
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + 
                this.$t("restoreVersion") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 2500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.Get();
          }else if (dataResponse.status == 2) {
            this.$router.push({
              name: "GPTModelDetail",
              query: {
                id: item.modelId,
              },
            });
          }
          self.dialog = false;
          self.dialog_version = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Save() {
      let self = this;
      self.dialog = true;
      try {
        if (self.GPTModel.modelId == null) {
          await self.$call.AddGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.GPTModel.modelId != null) {
          await self.$call.UpdateGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async Replace(modelid, modelName) {
      let self = this;
      self.dialog_replace = true;
      self.replace_modelid = modelid;
      self.replace_modelName = modelName;
      self.replace_modelName2 = "";
      self.replace_modelid_list = [];

      let raw = { page: 1, perPage: self.totalTable };
      self.$call.GetTableGPTModel(
        raw,
        (result) => {
          self.replace_modelid_list = [];
          if (result.status == 0) {
            let model = result.data.data.filter((o) => o.modelId == modelid)[0];

            if (model.isPublish == true) {
              let models = result.data.data.filter(
                (o) => o.modelId != modelid && o.isPublish == true
              );
              self.replace_modelid_lists = models;
            } else {
              let models = result.data.data.filter((o) => o.modelId != modelid);
              self.replace_modelid_lists = models;
            }
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (error) => {
          self.dialog = false;
          self.isSearch = false;
          alert(error);
        }
      );
    },
    async ReplaceSave() {
      let self = this;
      self.dialog = true;

      if (self.replace_modelid_list == undefined) {
        self.dialog = false;
        return;
      }

      let model_id = self.replace_modelid;
      // let GPTModel_model_display = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].modelDisplay;
      let GPTModel_model_id = self.replace_modelid_lists.filter(
        (o) => o.modelIDGroup == self.replace_modelid_list
      )[0].modelId;
      // let GPTModel_is_publish = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].isPublish;
      self.$call.ReplaceGPTModel(
        {
          source: model_id,
          destination: GPTModel_model_id,
        },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.status == 0) {
              let msgSuccess ="✔ Successfully Replaced!";
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.Get();
            }
          }
          self.dialog_replace = false;
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_replace = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async ReplaceChange(value) {
      let self = this;
      self.replace_modelid = value;
    },
    view(val) {
      let self = this;
      // self.dialog_version = false;
      self.view_modelID = val.modelId;
      self.isPage = "view model";
      self.dialog_View = true;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async Version(modelId, modelIDGroup) {
      let self = this;
      self.dialog = true;
      if (self.dialog_version == false) {
        this.options_version.page = 1;
        this.options_version.itemsPerPage = 5;
      }

      self.dialog_version = true;
      self.menus_modelid_version = modelId;
      self.menus_modeliddisplay_version = modelIDGroup;

      const { page, itemsPerPage } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: itemsPerPage,
        modelId: modelId,
        modelIDGroup: modelIDGroup,
      };

      self.$call.GetTableGPTModelVersioning(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.total == 1 &&
              dataResponse.data.data[0].isPublish == false
            ) {
              self.menus_version = [];
            } else {
              self.menus_version = dataResponse.data.data;
            }
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Exportfileconfig(id) {
      let self = this;
      let req = {
        modelID: id,
      };
      self.dialog = true;
      self.$call.ExportFileConfigModel(
        req,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse) {
            // สร้าง FileReader เพื่ออ่าน Blob
            const reader = new FileReader();

            // เมื่อ FileReader โหลดเสร็จ
            reader.onload = function () {
              try {
                // ๝ปลงผลลัพธ์จาฝ FileReader เป็น JSON
                const jsonResponse = JSON.parse(reader.result);
                //ทำฝารจัดฝารไฟล์
                let fileURL = window.URL.createObjectURL(
                  new Blob([JSON.stringify(jsonResponse, null, 2)])
                );
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;
                let fileName = `ExportFileConfigModel_${self.convertDateToString(
                  new Date(),
                  ""
                )}.json`;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
              } catch (error) {
                console.error("Error parsing JSON:", error);
              }
            };

            // เริ่มอ่าน Blob เป็นข้อความ
            reader.readAsText(new Blob([dataResponse]));
          }
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringWithTimeFromDate2(
        moment(date).toDate(),
        seperator
      );
    },
    processUpload(event) {
      let self = this;
      self.files = event;
      const reader = new FileReader();
      const file = self.files[0];
      reader.onload = (e) => {
        try {
          self.jsonData = JSON.parse(e.target.result); // ๝ปลง JSON ที่อัปโหลดได้
          self.ValidateFile(self.files);
          self.ImportFileModelConfig();
        } catch (error) {
          console.error("Invalid JSON file");
        }
      };
      reader.readAsText(file);
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("import_file", files[0]);
      self.uploadedFiles = files;
      self.entity = formDataDoc;
    },
    ImportFileModelConfig() {
      let self = this;
      self.dialog = true;
      self.$call.ImportFileModelConfig(
        self.jsonData,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + dataResponse.message;
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              background: 'transparent',
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.totalTable = self.totalTable + 1;
            self.Get();
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },

    onModelChange(value) {
      this.replace_modelName2 = this.replace_modelid_lists.find(e => e.modelIDGroup == value)?.modelName || '';
    },

    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.GetDate();
    this.headers = [
      {
        title: "Model ID",
        value: "model_id",
        align: "start",
        sortable: false,
        width: "105px",
      },
      {
        title: "Model Name",
        value: "ModelName",
        align: "start",
        sortable: true,
      },
      { title: " ", value: " ", align: "center", sortable: false },
      { title: "Provider", value: "Provider", align: "start", sortable: true },
      {
        title: "Model",
        value: "ModelNameDisplay",
        align: "center",
        sortable: true,
      },
      {
        title: "Created by",
        value: "CreateBy",
        align: "center",
        sortable: true,
      },
      { title: "Status", value: "IsPublish", align: "center", 
        width: "120px", sortable: true },
      {
        title: this.$t("Manage"),
        value: "Manage",
        align: "center",
        width: "100px",
        sortable: false,
      }
    ];
    this.headers_version_history = [
      { title: "Version", align: "start", sortable: false, width: "150px" },
      { title: "Modified", align: "start", sortable: false },
      { title: " ", align: "center", sortable: false },
      { title: "Modified By", align: "start", sortable: false },
    ];
    // this.Get();
  },
};
</script>

<style scoped>
/* Custom Delete Dialog Styles */
.delete-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.delete-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.delete-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #dc3545 !important;
  margin: 0 !important;
}

.delete-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.delete-close-icon:hover {
  background-color: #f8f9fa !important;
}

.delete-dialog-content {
  font-size: 14px !important;
  color: #212529 !important;
  text-align: left !important;
  padding: 24px !important;
  line-height: 1.6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.delete-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.delete-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.delete-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.delete-confirm-btn {
  background-color: #C30000 !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.delete-confirm-btn:hover {
  background-color: #c82333 !important;
}

.delete-confirm-btn .v-icon {
  margin-right: 6px;
}

.replace-close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}
.replace-close-btn .v-icon {
  margin-right: 6px;
}
.replace-save-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: 0 4px 10px rgba(195,46,14,0.25) !important;
}
.replace-save-btn .v-icon {
  margin-right: 6px;
}
</style>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* ปรับแต่ง responsive */
@media (max-width: 600px) {
  .justify-end {
    justify-content: flex-start;
  }
}

/* Custom Vertical Divider */
.custom-vertical-divider {
  width: 1px;
  height: 40px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 16px;
  align-self: center;
  border-radius: 1px;
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: transparent;
  padding: 4px 8px;
  border: none;
  transition: all 0.2s ease;
  gap: 16px;
}

/* Control Buttons */
.control-btn {
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.import-btn {
  border-radius: 12px !important;
  width: 120px;
  height: 40px;
  color: #C32E0E !important;
  font-size: 13px !important;
  background-color: transparent !important;
  border: 1px solid #C32E0E !important;
}

.create-btn {
  width: 120px;
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
  border-radius: 12px !important;
  margin: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
    min-width: auto;
  }
  
  .control-btn {
    flex: 1;
    margin: 0 2px;
  }
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}

/* Table improvements */
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Body rows - ไม่มี border, สะอาด */
:deep(.v-data-table tbody tr:hover) {
  background-color: #F8F9FA !important;
}

:deep(.v-data-table .v-table__wrapper > table > tbody > tr > td) {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr > th) {
  border: none !important;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

/* Search panel improvements */
.search-panel {
  gap: 16px;
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, 
              transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.headline {
  font-weight: 600 !important;
  font-size: 26px !important;
  color: #171717 !important;
  margin: 10px 0 0 15px;
}
.dialog-title-lable{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  margin: 0 -50px 10px -50px;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}

/* Dropdown items per page */
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
:deep(.v-data-table-footer .v-select) {
  width: 80px !important;
}

.config-input {
    margin-bottom: 0px;
}

.config-input :deep(.v-field) {
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.config-input :deep(.v-field:hover) {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

</style>
